/**
 * Attribute that carries a rendered note element's 1-based source line. `NoteMarkdown` sets it
 * (through the hast property `dataLine`), `NoteCard` reads it to put the caret on the clicked line.
 */
export const SOURCE_LINE_ATTRIBUTE = 'data-line';

/** Protocols a link in a note may use; anything else (javascript:, data:, file:, relative paths) is shown as text. */
export const NOTE_LINK_PROTOCOLS: readonly string[] = ['http:', 'https:', 'mailto:'];

/** Whether `url` is an absolute address with an allowed protocol (design 2026-10-15 §4.2). */
export function isSafeNoteUrl(url: string | undefined): url is string {
  if (url === undefined || url === '') return false;
  try {
    return NOTE_LINK_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
}
